<template>
<!-- 单行省市区设置 -->
<div class="citySingle">
	<el-cascader clearable style="width: 100%" :placeholder="placeholderDefault"
		:class="sendCityInfo.length > 0 ? 'setClass' : ''" :options="provinceList" :props="props"
		@active-item-change="handleItemChange" @change="provinceChange"></el-cascader>
</div>
</template>
<script>
export default {
	name: "citySingle",
	data() {
		return {
			provinceList: [],
			placeholderDefault: '请选择地区信息',
			props: {
				value: "value",
				children: "cities",
				label: "label",
				checkStrictly: true, //添加这个可以选择每一层级，不添加这个只能选择最后一级
				// multiple：true 设置多选
			},
		};
	},
	props: {
		sendCityInfo: {
			type: Array,
			default: () => {
				return []
			}
		}
	},
	watch: {
		sendCityInfo: {
			handler(newVal, oldVal) {
				// console.log('接受到的地址参数：', newVal);
				if (newVal.length != 0) {
					this.placeholderDefault = newVal.join(' / ')
				}
			}
		}
	},
	mounted() {
		//首先要加载一次省级数据
		this.getPosition(null, (res) => {
			// console.log(res);
		});
	},
	methods: {
		provinceChange(value) {
			this.$emit("getCityInfo", value);
		},
		// 地区联动获取数据
		getPosition(val, cb) {
			let vm = this; //查询省市县
			let params = { pid: 0 };
			//判断初始有没有val，查询省级的时候是没有val的，所以默认传值1,，
			//当你选择市级的时候，val是个数组。它会存储省级和市级的value值，
			//同理选择区级的时候，val数组长度是3，存储的是省市区三级的value值

			if (!val) {
				//初始化加载 yiji数据
				params = { pid: 0 };
			} else if (val.length === 1) {
				//加载二级 获取所有省份数据
				params = { pid: val[0] };
			} else if (val.length === 2) {
				//加载三级 获取市级数据
				params = { pid: val[1] };
			}else {
				//加载 4级   获取县级数据
				//注意：因为我们加载区级数据的时候不需要传省级的value值，只需要传市级的value值，如果你需要省级和市级数据一起传的话，在这里自己加上参数
				params = { pid: val[2] };
			}
			//请求后台数据
			this.$http.get(this.$const.common.getCityCode, params)
				.then((res) => {
					if (!val) {
						//初始化加载   查询省份数据
						vm.provinceList = res.data.map((e) => {
							return {
								value: e.areaId,
								label: e.areaName,
								cities: [],
							};
						});
					} else if (val.length === 1) {
						//加载二级    查询该省下市级数据
						vm.provinceList.map((item) => {
							if (item.value === val[0]) {
								item.cities = res.data.map((e) => {
									return { value: e.areaId, label: e.areaName, cities: [] };
								});
								// item.cities.unshift({ value: '', label: '全部', cities: [{ value: '', label: '全部',cities: [{ value: '', label: '全部' }] }] });
							}
						});
					}else if (val.length === 2) {
						//加载3级   查询该省市下县级数据
						vm.provinceList.map((item) => {
							if (item.value === val[0]) {
								item.cities.map((value) => {
									if (value.value === val[1]) {
										value.cities = res.data.map((e) => {
											return { value: e.areaId, label: e.areaName,cities: [] };
										});
									}
								});
							}
						});
					}  else {
						//加载4级   查询该省市下县级数据
						vm.provinceList.map((item) => {
							if (item.value === val[0]) {
								item.cities.map((value) => {
									if (value.value === val[1]) {
										value.cities.map((value1) => {
											if (value1.value === val[2]) {
												value1.cities = res.data.map((e) => {
											return { value: e.areaId, label: e.areaName };
										});
											}
										})
										
									}
								});
							}
						});
					}
					cb && cb(res);
				})
				.catch((err) => {
					console.log(err);
				});
		},
		// 一级二级改变的时候调取下一级数据
		handleItemChange(val) {
			this.getPosition(val);
		},
	},
};
</script>

<style lang="scss" scoped>
.citySingle .setClass /deep/ input::-webkit-input-placeholder {
	color: #606266;
}

.citySingle .setClass /deep/ input::-moz-placeholder {
	color: #606266;
}

.citySingle .setClass /deep/ input:-moz-placeholder {
	color: #606266;
}

.citySingle .setClass /deep/ input:-ms-input-placeholder {
	color: #606266;
}
</style>